import i18n from "@/libs/i18n"

export default [
    {
        path: "/roles",
        name: "list-roles",
        component: () => import("@/views/app/management/roles/RolesList.vue"),
        meta: {
            i18nTitle: {
                tc: "modules.roles.description",
                index: 2,
            },
            pageTitle: i18n.tc("modules.roles.description", 2),
            breadcrumb: [
                {
                    i18nText: {
                        tc: "modules.roles.description",
                        index: 2,
                    },
                    active: true,
                },
            ],
            action: "list",
            resource: "roles",
        },
    },
    {
        path: "/roles/:id",
        name: "edit-roles",
        component: () => import("@/views/app/management/roles/RolesEdit.vue"),
        meta: {
            i18nTitle: {
                t: "modules.roles.details",
            },
            pageTitle: i18n.t("modules.roles.details"),
            breadcrumb: [
                {
                    i18nText: {
                        tc: "modules.roles.description",
                        index: 2,
                    },
                    to: { name: "list-roles" },
                },
                {
                    i18nText: {
                        t: "modules.roles.details",
                    },
                    active: true,
                },
            ],
            action: "edit",
            resource: "roles",
        },
    },
]
